"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeCard = void 0;
exports.hydrateQRCodeElement = hydrateQRCodeElement;
exports.hydrateQRCodes = hydrateQRCodes;
var _litHtml = require("lit-html");
var _solidUi = require("solid-ui");
var _debug = require("../../utils/debug");
var qrcode = _interopRequireWildcard(require("qrcode"));
var _texts = require("../../texts");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* Part of this code was generated by AI Model: GPT-5.3-Codex */
/* Prompt: The QRCode has a label "link to profile" but it should
 be a VCARD with name, and link to profile. So when you scan it 
 it goes into your contacts. That's the current way works, IIRC. */

function isNamedNodeLike(value) {
  return Boolean(value && typeof value === 'object' && typeof value.uri === 'string');
}
function isStoreLike(value) {
  return Boolean(value && typeof value === 'object' && typeof value.any === 'function');
}
function resolveQRCodeArgs(arg1, arg2, arg3) {
  if (isNamedNodeLike(arg1)) {
    return {
      subject: arg1,
      store: isStoreLike(arg2) ? arg2 : undefined
    };
  }
  if (isNamedNodeLike(arg3)) {
    return {
      subject: arg3,
      store: isStoreLike(arg2) ? arg2 : undefined
    };
  }
  throw new Error('QRCodeCard requires a profile subject NamedNode.');
}
function normalizeEmail(value) {
  return (value || '').trim().replace(/^mailto:/i, '');
}
function normalizeTelephone(value) {
  return (value || '').trim().replace(/^tel:/i, '');
}
function isEmailValue(value) {
  const normalized = (value || '').trim();
  if (!normalized) return false;
  if (/^mailto:/i.test(normalized)) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}
function isPhoneValue(value) {
  const normalized = (value || '').trim();
  if (!normalized) return false;
  if (/^tel:/i.test(normalized)) return true;
  return /^[+()\-\s\d]{5,}$/.test(normalized);
}
function firstContactValue(store, subject, predicate, kind) {
  if (!store) return '';
  const candidates = store.each(subject, predicate);
  const isExpectedValue = kind === 'email' ? isEmailValue : isPhoneValue;
  for (const node of candidates) {
    if (!node) continue;
    const direct = node.value;
    if (typeof direct === 'string' && isExpectedValue(direct)) {
      return kind === 'email' ? normalizeEmail(direct) : normalizeTelephone(direct);
    }
    if (node.termType === 'NamedNode' || node.termType === 'BlankNode') {
      const doc = subject.doc();
      const inDocStatements = store.statementsMatching(node, _solidUi.ns.vcard('value'), null, doc);
      const anyGraphStatements = store.statementsMatching(node, _solidUi.ns.vcard('value'));
      for (const statement of [...inDocStatements, ...anyGraphStatements]) {
        const viaValue = statement.object?.value;
        if (typeof viaValue === 'string' && isExpectedValue(viaValue)) {
          return kind === 'email' ? normalizeEmail(viaValue) : normalizeTelephone(viaValue);
        }
      }
    }
  }
  return '';
}
const qrCodeRenderOptions = {
  type: 'svg',
  color: {
    dark: '#000000',
    light: '#ffffff'
  }
};
function renderQRCodeSvg(value) {
  return new Promise((resolve, reject) => {
    qrcode.toString(value, qrCodeRenderOptions, (error, svg) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(svg);
    });
  });
}
async function hydrateQRCodeElement(QRCodeElement) {
  const value = QRCodeElement.getAttribute('data-value');
  if (!value) {
    (0, _debug.error)('QRCode data-value missing');
    return;
  }
  const imageContainer = QRCodeElement.querySelector('.qrcode-card__image');
  if (!imageContainer) {
    (0, _debug.error)('QRCode image container missing');
    return;
  }
  try {
    imageContainer.innerHTML = await renderQRCodeSvg(value);
  } catch (error) {
    (0, _debug.error)('QRcode error!', error);
  }
}
async function hydrateQRCodes(root) {
  const QRCodeElements = Array.from(root.querySelectorAll('.qrcode-card'));
  if (!QRCodeElements.length) {
    (0, _debug.error)('QRCode Ele missing');
    return;
  }
  await Promise.all(QRCodeElements.map(element => hydrateQRCodeElement(element)));
}
const QRCodeCard = (arg1, arg2, arg3) => {
  const {
    subject,
    store
  } = resolveQRCodeArgs(arg1, arg2, arg3);
  const name = _solidUi.utils.label(subject);
  const escapeVCardValue = value => {
    return (value || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  };
  const safeName = escapeVCardValue(name || subject.uri);
  const safeUrl = escapeVCardValue(subject.uri);
  const email = firstContactValue(store, subject, _solidUi.ns.vcard('hasEmail'), 'email');
  const telephone = firstContactValue(store, subject, _solidUi.ns.vcard('hasTelephone'), 'tel');
  const vCardLines = ['BEGIN:VCARD', 'VERSION:4.0', `FN:${safeName}`, `URL:${safeUrl}`];
  if (email) {
    vCardLines.push(`EMAIL;TYPE=internet:${escapeVCardValue(email)}`);
  }
  if (telephone) {
    vCardLines.push(`TEL:${escapeVCardValue(telephone)}`);
  }
  vCardLines.push('END:VCARD');
  const vCard = vCardLines.join('\r\n');
  return (0, _litHtml.html)`
    <figure 
      class="qrcode-card"
      data-value="${vCard}"
      data-testid="qrcode-card"
      aria-labelledby="qr-code-caption"
      role="img"
      aria-describedby="qr-code-description"
    >
      <div class="qrcode-card__frame">
        <div 
          class="qrcode-card__image"
          aria-label="Static QR code containing contact information for ${name}"
          role="img"
          tabindex="0"
        >
        </div>
      </div>
      <figcaption 
        id="qr-code-caption" 
        class="qrcode-card__caption"
      >
        ${_texts.scanQrToConnectText}
      </figcaption>
      <div 
        id="qr-code-description" 
        class="sr-only"
      >
        This is a static QR code containing vCard information for ${name}, including profile URL ${subject.uri}. The QR code is not interactive.
      </div>
    </figure>
  `;
};
exports.QRCodeCard = QRCodeCard;